module.exports = __webpack_public_path__ + "img/official-qr-code.c94898a9.jpg";